import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/system/processes',
    name: 'POST_PROCESS',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
